import { Step } from 'react-joyride';

export const logsTourSteps: Step[] = [
  {
    target: '[data-tour="logs-header"]',
    content: (
      <div>
        <h4>Activity Logs</h4>
        <p>
          Track all system activities, user actions, and events. Monitor changes, identify issues,
          and maintain security through comprehensive logging.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="log-filters"]',
    content: (
      <div>
        <h4>Filter Logs</h4>
        <p>
          Filter logs by date range, user, action type, or event category to quickly find specific
          activities.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="search-logs"]',
    content: (
      <div>
        <h4>Search Logs</h4>
        <p>
          Search through log entries by keywords, user names, IP addresses, or specific actions.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="logs-table"]',
    content: (
      <div>
        <h4>Logs Table</h4>
        <p>
          View detailed log entries with timestamps, users, actions performed, and additional
          context. Click on any entry for more details.
        </p>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '[data-tour="export-logs"]',
    content: (
      <div>
        <h4>Export Logs</h4>
        <p>
          Export logs to CSV or PDF for external analysis, compliance reporting, or archival
          purposes.
        </p>
      </div>
    ),
    placement: 'left'
  }
];
